<cft-holy-grail-grid-sidenav [items]="items"> </cft-holy-grail-grid-sidenav>
